<template>
  <div class="appBody bg-grey-light min-vh-100 pb-44" v-if="!loading && projectObj">
    <little-header></little-header>
    <div class="recHeader">
      <div class="nei w-100 p-3">
        <p class="mb-0  font-15 text-white line-22 van-multi-ellipsis--l2">
          {{projectObj.name}}
        </p>
        <!--        <p v-if="projectObj.credit > 0" class="mb-0 mt-2 font-14 text-white line-22 van-multi-ellipsis&#45;&#45;l2">-->
        <!--          项目学时要求：{{projectObj.credit}}学时-->
        <!--        </p>-->
      </div>
    </div>
    <div class="b-title pt-28 pb-3 line-20 d-flex align-items-center">
      选择课程
    </div>
    <div class="list-cotent">
      <recommend-course :project="projectObj" :coursesList=recommendList :proTimeObj="proTimeObj"></recommend-course>
    </div>
    <little-footer class=""></little-footer>
  </div>
</template>

<script>
  import recommendCourse from '@/page/project/component/recommendCourse'
  import LittleHeader from "@/components/littleHeader";
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import Vue from 'vue';
  import {Icon, Progress, Popup, Skeleton, Search, NavBar, Overlay} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Overlay);
  Vue.use(NavBar);
  Vue.use(Search);
  Vue.use(Skeleton);
  Vue.use(Popup);
  Vue.use(Progress);
  Vue.use(Icon);


  export default {
    name: "recommendProject",
    data() {
      return {
        value: '',
        title: '选择课程',
        smallTitle: '必选课程',
        isMust: true,
        projectId: '',
        projectObj: {},
        recommendList: [],
        mustCourseList: [],
        courseList: [],
        myTitle: '',
        showShare: false,
        shareObj: {},
        myCourseList: [],
        mapObj: {},
        proTimeObj: {},
        loading: false,
      }
    },
    components: {
      recommendCourse,
      LittleHeader,
      littleFooter
    },
    mounted() {
      this.projectId = this.$route.params['id'];
      this.getProject();
    },
    methods: {
      getProject() {
        this.loading = true;
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.projectObj = res;
          this.loading=false;
          this.proTimeObj.proLearningStartTime = this.projectObj.learningStartTime;
          this.proTimeObj.proLearningEndTime = this.projectObj.learningEndTime;
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.projectObj.name
          });
          sessionStorage.setItem("currentProject", JSON.stringify(this.projectObj));
         this.getCourseList();
        })
      },
      getCourseList() {
        if (this.projectObj && this.projectObj.userProject && this.projectObj.userProject.courseList && this.projectObj.userProject.courseList.length > 0) {
          this.myCourseList = this.projectObj.userProject.courseList;
          for (let m of this.myCourseList) {
            this.mapObj[m.courseId] = m;
          }
        }

        if (this.projectObj.courseList && this.projectObj.courseList.length > 0) {
          for (let v of this.projectObj.courseList) {
            if(!this.mapObj[v.courseId]) {
              this.recommendList.push(v);
            }
          }
        }
      },
    }
  }
</script>

<style>
  .recHeader {
    background-image: url("/static/img/pro/com-bg.png");
    padding-top: 30% !important;
    background-size: 100% auto;
    width: 100%;
    background-repeat: no-repeat
  }

  .recHeader .nei {
    position: absolute;
    top: 3rem;
    margin: 0 auto;
    max-width: 640px;
  }
  .recHeader .van-search__content {
    background-color: #f7f7f726;
    padding-left: 1.75rem;
  }

  .recHeader .van-search {
    padding: 0 1rem;
  }

  .recHeader .van-search .van-cell {
    padding: 0.625rem 0;

    display: flex;
    align-items: center;
  }

  .recHeader .van-icon-search {
    color: #e3e3e3 !important;
    font-size: 1rem;
  }

  .recHeader .van-field__control {
    color: #ffffff;
    line-height: 1rem;
  }

  .recHeader .van-field__value {
    font-size: .9375rem;
    padding-right: 1rem;
    line-height: 1rem;
  }

  .recHeader .van-field__body .van-icon {
    font-size: 1rem;
    color: #e3e3e3 !important;
  }

  .recHeader .van-field__left-icon {
    margin-right: .5rem;
    line-height: 1rem;
  }

  .recHeader input::-webkit-input-placeholder {
    color: #e3e3e3 !important;
  }

  .recomd-top .van-nav-bar__left, .recomd-top .van-nav-bar__right {
    padding: 0 !important;
  }

  .recomd-top .van-nav-bar__title {
    max-width: 100%;
    width: 100%;
    padding-left: 1.5rem;
    font-size: .9375rem;
  }

  .recomd-top .van-nav-bar__arrow {
    font-size: 1.5rem;
    color: white !important;
  }

  .recomd-top .van-nav-bar {
    height: 2.5rem;
    overflow: hidden;
  }

  .recomd-top .van-hairline--bottom::after {
    border: none !important;
  }
</style>
